import Auth from "./auth";
import Bid from "./bid";
import Driver from "./driver";
import Letter from "./letter";
import Load from "./load";
import Order from "./order";
import User from "./user";
import Location from "./location";
import Weather from "./weather";
import Chat from './chat';

class ApiService {
  public user = new User();
  public auth = new Auth();
  public order = new Order();
  public letter = new Letter();
  public driver = new Driver();
  public bid = new Bid();
  public load = new Load();
  public location = new Location();
  public weather = new Weather();
  public chat = new Chat();
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ApiService();
